module.exports = __webpack_public_path__ + "static/img/diandi.d6feb2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/diandi.png
// module id = EIXy
// module chunks = 1